<template lang="pug">
  .searchPanel
    app-search.margin-bottom(
      v-if="searchObject.simpleSearch"
      place-holder="Informe o Nome/Razão Social ou CPF/CNPJ do usuário",
      v-model="searchObject.simpleFieldValue"
      v-debounce="emitSimpleSearch"
    )
    .advancedSearch.margin-top.margin-bottom(v-if="!searchObject.simpleSearch")
      form(@submit.prevent="$emit('search', searchObject.simpleFieldValue)")
        .panel
          el-row(:gutter="20")
            el-col(:span="12")
              app-label(
                label="Nome/Razão Social:",
                :required="false"
              )
              el-input(
                v-debounce="emitAdvancedSearch"
                v-model="searchObject.advancedObject.nomeRazaoSocial",
              )
            el-col(:span="12")
              app-label(
                label="CPF/CNPJ:",
                :required="false"
              )
              el-input(
                v-model="searchObject.advancedObject.cpfCnpj",
                class="input-with-select",
                v-mask="['###.###.###-##', '##.###.###/####-##']",
                v-debounce="emitAdvancedSearch"
              )
          el-row.margin-top(:gutter="20")
            el-col(:span="12")
              app-label(
                label="E-mail:",
                :required="false"
              )
              el-input(
                v-model="searchObject.advancedObject.email",
                class="input-with-select",
                v-debounce="emitAdvancedSearch"
              )
            el-col(:span="12")
              app-input-perfil.no-padding(
                v-model="searchObject.advancedObject.perfis",
                :required="false",
                @input="emitAdvancedSearch",
                :isFiltro="true"
              )

          el-row.margin-top(:gutter="20")
            el-col(:span="12")
              app-label(
                label="Situação:",
                :required="false"
              )
              el-select.full-width(
                v-model="situacao",
                placeholder='Selecione',
                @change="changeSituacao"
              )
                el-option(label='Todos', value='TODOS')
                el-option(label='Ativo', value='ATIVO')
                el-option(label='Inativo', value='INATIVO')
                el-option(label='Bloqueado', value='BLOQUEADO')

            el-col(:span="12")
              app-label(
                label="Assinatura simbólica:"
                :required="false"
              )
              el-select.full-width(
                v-model="hasAssinaturaSimbolica"
                placeholder="Selecione"
                @change="changeHasAssinaturaSimbolica"
              )
                el-option(label="Possui", :value="true")
                el-option(label="Não possui", :value="false")

          el-row.margin-top(:gutter="20")
            el-col(:span="12")
              app-label(
                label="Token:"
                :required="false"
              )
              el-select.full-width(
                v-model="hasToken"
                placeholder="Selecione"
                @change="changeHasToken"
              )
                el-option(label="Possui", :value="true")
                el-option(label="Não possui", :value="false")

            el-col(:span="12")
              app-label.input.date(
                label="Data de validade do Token:"
                :required="false"
              )
              el-date-picker(
              v-model="dataValidadeToken"
              type="daterange"
              unlink-panels
              range-separator="-"
              start-placeholder="Início"
              end-placeholder="Fim"
              format="dd/MM/yyyy"
              @change="changeDataValidadeToken"
            )

    el-row
      el-button.no-padding(
        type="text",
        @click="changePesquisa"
      ) {{ tituloPesquisa }}
      el-button.no-padding(
        type="text",
        @click="limpar"
      ) Limpar
    el-row(v-if="!searchObject.simpleSearch")
      .button
        el-button(
          @click="emitAdvancedSearch",
          type="success"
        )
          span.center
            i.fa.fa-search
            b &nbsp Pesquisar

</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import AppSearch from '@/components/AppSearch'
import AppLabel from '@/components/AppLabel'
import AppInputPerfil from '@/screens/portal/seguranca/components/AppInputPerfil.vue'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

const emptyAdvancedSearch = () => ({
  nomeRazaoSocial: '',
  cpfCnpj: '',
  email: '',
  perfis: [],
  ativo: undefined,
  isBloqueado: undefined,
  hasAssinaturaSimbolica: '',
  hasToken: '',
  dataValidadeTokenInicial: '',
  dataValidadeTokenFinal: ''
})

const confSituacao = {
  TODOS: {
    ativo: undefined,
    isBloqueado: undefined
  },
  ATIVO: {
    ativo: true,
    isBloqueado: false
  },
  INATIVO: {
    ativo: false,
    isBloqueado: false
  },
  BLOQUEADO: {
    ativo: undefined,
    isBloqueado: true
  }
}

export default {

  components: { AppSearch, AppInputPerfil, AppLabel },

  props: {
    placeHolder: {
      type: String,
      default: filtro.placeholder,
      required: false
    }
  },

  data () {
    return {
      searchObject: {
        simpleFieldValue: '',
        advancedObject: emptyAdvancedSearch(),
        simpleSearch: true
      },
      situacao: undefined,
      setoresNaoFormatados: {
        EXTERNO: 'Externo',
        TECNICO_DE_CAMPO: 'Tecnico de campo',
        RELATORIOS: 'Relatórios',
        PRODUTIVIDADE: 'Produtividade'
      },
      perfis: [],
      hasAssinaturaSimbolica: '',
      hasToken: '',
      dataValidadeToken: {
        dataValidadeTokenInicial: '',
        dataValidadeTokenFinal: ''
      }
    }
  },

  computed: {

    tituloPesquisa () {
      return this.searchObject.simpleSearch ? 'Pesquisa avançada' : 'Pesquisa simplificada'
    }
  },

  methods: {
    ...mapActions({
      findAllPerfis: 'usuario/findAllPerfis'
    }),

    limpar () {
      this.limparFiltro()
      this.$emit('clear')
    },

    changePesquisa () {
      this.limparFiltro()
      this.searchObject.simpleSearch = !this.searchObject.simpleSearch
      this.$emit('tipoPesquisaChanged', this.searchObject.simpleSearch)
    },

    pesquisar () {
      this.$emit('advancedSearch', this.searchObject.advancedObject)
    },

    emitAdvancedSearch () {
      this.$emit('advancedInput', this.searchObject.advancedObject)
    },

    emitSimpleSearch () {
      this.$emit('simpleSearch', this.searchObject.simpleFieldValue)
    },

    changeSituacao () {
      this.searchObject.advancedObject.ativo = confSituacao[this.situacao].ativo

      this.searchObject.advancedObject.isBloqueado = confSituacao[this.situacao].isBloqueado

      this.emitAdvancedSearch()
    },

    changeHasAssinaturaSimbolica () {
      this.searchObject.advancedObject.hasAssinaturaSimbolica = this.hasAssinaturaSimbolica

      this.emitAdvancedSearch()
    },

    changeHasToken () {
      this.searchObject.advancedObject.hasToken = this.hasToken

      this.emitAdvancedSearch()
    },

    changeDataValidadeToken () {
      if (this.dataValidadeToken) {
        this.searchObject.advancedObject.dataValidadeTokenInicial = moment(this.dataValidadeToken[0]).format('DD/MM/YYYY 00:00:00')
        this.searchObject.advancedObject.dataValidadeTokenFinal = moment(this.dataValidadeToken[1]).format('DD/MM/YYYY 23:59:00')
      } else {
        this.searchObject.advancedObject.dataValidadeTokenInicial = ''
        this.searchObject.advancedObject.dataValidadeTokenFinal = ''
      }
      this.emitAdvancedSearch()
    },

    limparFiltro () {
      if (this.searchObject.simpleSearch) {
        this.searchObject.simpleFieldValue = ''
      } else {
        this.searchObject.advancedObject = emptyAdvancedSearch()
        this.situacao = ''
        this.hasToken = ''
        this.hasAssinaturaSimbolica = ''
        this.dataValidadeToken = ''
      }
    }
  }

}
</script>

<style lang="scss" scoped>

  .searchPanel {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    .button-group {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    .no-padding{
      padding: 0;
    }

    .panel{

      .margin-top{
        margin-top: 10px;
      }

      .titulo{
        font-size: 14px;
      }

    }

    .btn {
      padding: 8px;
    }

  }

  .full-width {
    width: -webkit-fill-available;
  }

  .almost-full-width {
    width: 50%
  }

  .button {
    display: flex;
    justify-content: flex-end;
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/components/AppSearchUsuarios.vue